<template>
    <div class="mb-2 text-end">
        <button class="btn btn-secondary" @click="printTable">🖨️ Print</button>
    </div>
    <form @submit.stop.prevent="getUserExpenditures">
        <div ref="printSection" class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th>USERNAME</th>
                        <th>FULL NAME</th>
                        <th>CITY</th>
                        <th>SCANNED QTY</th>
                        <th>FUNDS</th>
                        <th>SPENT</th>
                        <th>TYPE</th>
                    </tr>
                    <tr class="d-print-none">
                        <th><input type="text" class="form-control" v-model="expSearchModel.name_user" /></th>
                        <th><input type="text" class="form-control" v-model="expSearchModel.fullname_user" /></th>
                        <th><input type="text" class="form-control" v-model="expSearchModel.name_mun" /></th>
                        <th><input type="text" class="form-control" v-model="expSearchModel.scannedqty" /></th>
                        <th><input type="text" class="form-control" v-model="expSearchModel.funds" /></th>
                        <th><input type="text" class="form-control" v-model="expSearchModel.spent" /><button
                                class="d-none" type="submit"></button></th>
                        <th><input type="text" class="form-control" v-model="expSearchModel.source_type" /><button
                                class="d-none" type="submit"></button></th>
                    </tr>

                </thead>
                <tbody>
                    <tr v-for="ux in userExpenditures" :key="ux.syspk_user">
                        <td>{{ ux.name_user }}</td>
                        <td>{{ ux.fullname_user }}</td>
                        <td>{{ ux.name_mun }}</td>
                        <td style="text-align: center;">{{ ux.scannedqty }}</td>
                        <td style="text-align: end;">{{ ux.funds.toLocaleString() }}</td>
                        <td style="text-align: end;">{{ ux.spent.toLocaleString() }}</td>
                        <td>{{ ux.source_type }}</td>
                    </tr>
                    <tr v-if="userExpenditures.length > 0" class="bg-warning total-row">
                        <td colspan="3">Total</td>
                        <td style="text-align: center;">{{ formatNumber(totalScanned) }}</td>
                        <td style="text-align: end;">{{ formatNumber(totalFunds) }}</td>
                        <td style="text-align: end;">{{ formatNumber(totalSpent) }}</td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </form>
</template>

<script setup>
import spinnerService from '@/services/spinnerService';
import userService from '@/services/userService';
import { onMounted, ref, computed } from 'vue';

const userExpenditures = ref([]);
const expSearchModel = ref({ name_user: "" })
const getUserExpenditures = async () => {
    spinnerService.show();
    userExpenditures.value = await userService.searchUserExpenditures(expSearchModel.value);
    spinnerService.hide();
};

const totalFunds = computed(() => {
    return userExpenditures.value.reduce((sum, ux) => sum + (Number(ux.funds) || 0), 0);
});

const totalSpent = computed(() => {
    return userExpenditures.value.reduce((sum, ux) => sum + (Number(ux.spent) || 0), 0);
});

const totalScanned = computed(() => {
    return userExpenditures.value.reduce((sum, ux) => sum + (Number(ux.scannedqty) || 0), 0);
});

const formatNumber = (num) => {
    return num?.toLocaleString() ?? '0';
};

const printSection = ref(null);

const printTable = () => {
    const content = printSection.value.innerHTML;
    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.write('<html><head><title>Print Table</title>');
    printWindow.document.write('<style>table { width: 100%; border-collapse: collapse; } th, td { border: 1px solid #ccc; padding: 8px; }</style>');
    printWindow.document.write('</head><body>');
    printWindow.document.write(content);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
};

onMounted(() => {
    getUserExpenditures();
});

</script>

<style scoped>
.total-row {
    font-weight: bold;
    background-color: #f0f0f0;
}
</style>